var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3113 12.891C20.1683 14.4367 19.5881 15.9098 18.6385 17.1378C17.6889 18.3658 16.4093 19.298 14.9493 19.8253C13.4892 20.3526 11.9092 20.4532 10.3941 20.1153C8.87903 19.7775 7.49147 19.0151 6.39382 17.9174C5.29616 16.8198 4.5338 15.4322 4.19594 13.9171C3.85807 12.402 3.95868 10.822 4.48598 9.36201C5.01328 7.90199 5.94547 6.62233 7.17349 5.67276C8.4015 4.72318 9.87454 4.14297 11.4203 4C10.5148 5.22441 10.079 6.73318 10.1921 8.2518C10.3052 9.77043 10.9597 11.198 12.0365 12.2748C13.1133 13.3516 14.5408 14.0061 16.0595 14.1192C17.5781 14.2323 19.0869 13.7964 20.3113 12.891Z",
    fill: "#183A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon-icon.8539752b6a5219a94af5e75fb9288f4b.svg";
export { ForwardRef as ReactComponent };